module.exports = __webpack_public_path__ + "img/album15_17.9ba9e383.jpg";